import { c as _c } from "react/compiler-runtime";
import { FacebookIcon } from "@/components/footer/social-links";
import { PromotionalCardBase } from "../card-base";
import { PromotionalCardProps, REVIEW_URLS } from "../types";
export function FacebookReviewCard(t0) {
  const $ = _c(3);
  const {
    className
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <FacebookIcon className="w-full h-full" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== className) {
    t2 = <PromotionalCardBase icon={t1} title="Join Us on Facebook" description="Get early access to new listings, tips & real estate insights" ctaText="Like Our Page" href={REVIEW_URLS.FACEBOOK} className={className} iconColor="text-[#1877F2]" />;
    $[1] = className;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}